
import {ViewChild, Component, OnInit, Input, Output, AfterViewInit, EventEmitter } from '@angular/core';

import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery-9';
//npm install ngx-gallery --save; https://www.npmjs.com/package/ngx-gallery

import { ConstService } from '../../const.service';



@Component({
    selector: 'app-input-image',
    templateUrl: './input.image.component.html'
  })
export class InputImageComponent implements OnInit {
    
    @Input() thumbnailsSize: number = 15;
    @Input() fileNames: string = "";
    @Input() height: string = "300px";

    galleryOptions: NgxGalleryOptions[];
    galleryImages: NgxGalleryImage[];

    displayCaneva : boolean;

    constructor(private constService: ConstService) { }

    ngOnInit() { 
        this.galleryOptions = [
            {
                width: '100%',
                height: this.height,
                thumbnailsColumns: 4,
                imageAnimation: NgxGalleryAnimation.Slide,
                imageInfinityMove: true,
                imageAutoPlay: true,
                imageAutoPlayInterval: 9000,
                imageAutoPlayPauseOnHover: true,
                thumbnailsPercent: this.thumbnailsSize,
                thumbnailsMargin: 5,
                thumbnailMargin: 10,
                previewCloseOnClick:false,
                previewInfinityMove: true,
                previewZoom: true,
                previewRotate: true,
                //imageActions: [{icon:'', titleText:'test', (onClick):{e -> {}} }],
                previewZoomMax: 5
            }
        ];
        this.displayCaneva = false;
        this.galleryImages = [];
        this.addFileNames(this.fileNames);
    }

    addFileNames(names : string) {
        console.log(">>>app-input-image:::addFileNames:::"+names);
        if(names === null || names === undefined){
            return;
        }
        let images : string[] = names.split(";");
        if(images.length < 1) {
            return;
        }
        for(var i=0; i<images.length; i++) {
            if(images[i] !== "") {
                images[i] = this.constService.imageUrlOpenStackKYC(images[i]);
                this.galleryImages.push({small: images[i], medium: images[i], big: images[i]});
            }
        }
        if(this.galleryImages.length > 0) {
            this.displayCaneva = true;
        }
    }

    clearFileNames(){
        console.log(">>>app-input-image:::clearFileNames:::");
        this.displayCaneva = false;
        this.galleryImages = [];
    }

}

